<template>
    <main>
        <div class="border p-3 rounded-3 mx-1 mb-3"
             style=" margin-bottom: 10px; display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 1rem;">
            <div style="grid-column: 1/-1">
                <label>Prepared by Parent Liaison Staff: </label>
            </div>

            <div class=" d-flex">
                <label class="me-2">Date: </label> <span> {{this.PL && this.PL.date}}</span>
            </div>
            <div class=" d-flex">
                <label class="me-2">Signature: </label> <span> {{this.PL && this.PL.CONname }}</span>
            </div>

            <div style="grid-column: 1/-1">
                <label>Prepared by Principal: </label>
            </div>

            <div class=" d-flex">
                <label class="me-2">Date: </label> <span> {{this.principal && this.principal.date}}</span>
            </div>
            <div class=" d-flex">
                <label class="me-2">Signature: </label> <span> {{this.principal && this.principal.CONname }}</span>
            </div>

            <div style="grid-column: 1/-1">
                <label>Prepared by Finance: </label>
            </div>

            <div class=" d-flex">
                <label class="me-2">Date: </label> <span> {{this.finance && this.finance.date}}</span>
            </div>
            <div class=" d-flex">
                <label class="me-2">Signature: </label> <span> {{this.finance && this.finance.CONname }}</span>
            </div>
        </div>
    </main>
</template>

<script>
    import { getFormatDate } from "@/helper/utily";

    export default {
        props: ["approverList"],
        data() {
            return {
                PL: null,
                principal: null,
                finance: null
            };
        },
        watch: {
            approverList: function(value) {
                this.handleApproval();
            }
        },
        mounted() {
            this.handleApproval();
        },
        methods: {
            handleApproval() {
                let submit = this.approverList?.find(d => d.Action === "Submit");
                if (submit) {
                    this.PL = submit;
                    this.PL.date = submit?.CreatedAt ? getFormatDate(submit?.CreatedAt) : "";
                }

                let Approve = this.approverList?.find(d => d.Action === "Approve");
                if (Approve) {
                    this.principal = Approve;
                    this.principal.date = Approve?.CreatedAt ? getFormatDate(Approve?.CreatedAt) : "";
                }

                let Verify = this.approverList?.find(d => d.Action === "Verify");
                if (Verify) {
                    this.finance = Verify;
                    this.finance.date = Verify?.CreatedAt ? getFormatDate(Verify?.CreatedAt) : "";
                }

            }
        }
    };
</script>